let promise = null;

export const loadGoogleMaps = (apiKey) => {
  if (window.google?.maps) return Promise.resolve(window.google.maps);
  if (promise) return promise;

  promise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () =>
      window.google?.maps
        ? resolve(window.google.maps)
        : reject(new Error('Google Maps failed to initialise'));
    script.onerror = () => {
      promise = null;
      reject(new Error('Failed to load Google Maps script'));
    };
    document.head.appendChild(script);
  });

  return promise;
};